const ZERO_DECIMALS_CURRENCIES = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];

const moneyNoSymbol = {
  apply: (value: number, currency = 'BRL') => {
    const hasDecimal = !ZERO_DECIMALS_CURRENCIES.includes(currency);
    const formattedValue = value?.toLocaleString('pt-BR', {
      ...(hasDecimal && { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    });
    return formattedValue;
  },
  clean: (value: string, currency = 'BRL') => {
    const cleanValue = value?.replace(/\D/g, '');
    const parsedValue = Number(cleanValue);
    const hasNoDecimal = ZERO_DECIMALS_CURRENCIES.includes(currency);
    return hasNoDecimal ? parsedValue : parsedValue / 100;
  },
};

export default moneyNoSymbol;
